module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Italian’s Ruthless Marriage Bargain")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("EFERRING")])])])]), _vm._v(" to his notes occasionally, Tom Trent spoke at length. He knew the man who had had him flown back from his Stateside holiday on Concorde for this meeting well enough to know he wouldn’t want him to pull his punches, and he didn’t.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Elbows set on the mahogany desktop, long brown fingers steepled, the figure behind the desk listened Tom out in silence. Tom could only imagine how he was feeling, for his dark patrician features gave no clue whatsoever of what was going on in his mind—a mind that was the sharpest that Tom, who was no intellectual slouch himself, had ever encountered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘So that’s about it, then,’ Tom concluded leaning back in his seat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luca didn’t respond immediately; instead he rose to his feet in one fluid motion. At six feet five fit inches of solid bone and muscle he made an imposing figure. His dark, contemplative gaze rested on his friend for several moments before he sighed and began to pace the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he watched the languid, loose-limbed tread of the tall man Tom, not a person renown for his imaginative flights, found the image of a sleek panther, its natural instincts confined within cage bars, appear in his head.")])])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After a second circuit of the room Luca came to halt by the big desk and, placing his hands palm down on the gleaming surface, he leant towards the other man. The thick curling eyelashes, which Tom’s own wife had declared to be sinfully sexy, lifted from sharp, jutting cheekbones and Tom found himself on the receiving end of the famous Di Rossi stare. It wasn’t a comfortable place to be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘So what you’re saying is the only foolproof way to avoid a custody battle would be for me to find a wife, preferably one who has a child of her own?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tom shook his head. It was typical of Luca to condense thirty minutes’ worth of complicated legal explanation in one sentence, but then Gianluca Di Rossi was not a man who used two words when one would do. Like his words, his actions too were always focused and to the point.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Small talk")])]), _vm._v(" was not Luca’s thing!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The flip side of this was that when other people wrote memos and had endless meetings Luca acted. Making decisions was not something that Luca agonised about; he didn’t feel the need for other people to validate his actions or anyone else to blame when those actions had consequences. So the fact that some people called him reckless and others called him inspired did not matter to him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So far his supreme self-belief had been more than justified by the spectacular success of the empire he had carved out of nothing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, I hadn’t thought of it that way, but a ready-made family would really damage their case, if not kill it stone-dead. If you’re going to interview for the job, a couple of kids, one of each would be good.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("His humour produced no lightening of the sombre, brooding expression in the dark penetrating eyes fixed unblinking on his face, nor any relaxation of the taut lines in Luca’s lean, ")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("hard face. But then, Tom conceded, feeling inexcusably insensitive, I wouldn’t feel inclined to laugh at my pathetic witticisms if someone were trying to take my kid off me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘A ready-made family…’ Luca repeated slowly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Bad joke, but it’s not like I’m telling you anything you didn’t already know.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Sometimes it takes someone else to point out the obvious before you see what’s staring you straight in the face,’ Luca observed somewhat enigmatically before folding his long, lean length into his chair once more.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("Hands rested lightly on the leather arm-rests, he tilted the head-rest back and stared up at the high ceiling. The London office of Di Rossi International having recently moved from its cramped modern offices to this Georgian terrace, which had been restored with meticulous attention being paid to period detail and very little to cost, he found himself looking at some pretty fine plaster mouldings.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("The shadow cast by the downward sweep of Luca’s lashes effectively concealed his deep-set eyes and expression from the other man. To all intents and purposes he appeared relaxed, but as people over the years had learnt, frequently to their cost, with Luca appearances could be deceptive.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Di Rossi is at his most dangerous when cornered!’ a shrewd economic analyst had once written. This went tenfold for his personal life, which he guarded jealously. And at that moment his personal life was under attack.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘You could always put an advert in the personal column. All right,’ Tom conceded quickly with a grimace, ‘that wasn’t funny either. ‘But lighten up, it’s not like I’m actually suggesting you go out and get married! For one thing they don’t stand a chance in hell of winning the case.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘But they will make sure my name is dragged through the mud.’")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘The negative effect on the company will only be temporary Luca,’ Tom was quick to point out soothingly. ‘And that’s not just spin, I promise you. Di Rossi is far too solid in the market-place to suffer any long-term damage from a court case.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One sardonic brow arched. ‘Your concern for my financial interests is laudable.’ The accented drawl became diamond-hard as he added, ‘However, the damage on Valentina might not be so temporary.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tom winced. ‘Ah, God, yes, what was I thinking about? Sorry, Luca.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luca lifted his head. ‘Why?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tom blinked and looked nonplussed by this abrupt question. ‘Why what?’ he queried, his manner guarded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Why should I not get married?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You’re not serious!’ Again he received the look. ‘Well, other than the odd hundred or so reasons that spring to mind, it would be totally—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Necessary, according to you,’ Luca interjected seamlessly. ‘If I want to kill off the case before it gets to court. And I’d do anything it takes to protect Valentina from being dragged through that. Being exposed to those vultures.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Looking into those implacable eyes, Tom realised this was no figure of speech. In a world where people frequently said things they didn’t mean for effect, it had taken him some time to catch onto the fact that when Luca said something that was exactly what he meant!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was the lawyer who felt the need to break the ensuing heavy silence.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘To them it must seem you moved her to England to deliberately make it harder for them to have access…’ he suggested tentatively.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Luca ran a hand over his smooth shaven chiselled jaw and gave a wolfish smile. ‘I did.’")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Then when you refused to give them unaccompanied access—’ Tom shrugged ‘—you "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("must")])]), _vm._v(" have known how they’d react. Natalia Corradi hates you, Luca, and Valentina is her granddaughter.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("my")])]), _vm._v(" daughter,’ Luca flashed back, a lick of flame in his glittering eyes that made his friend draw back in his seat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Don’t kill the messenger, mate,’ he pleaded, holding out his hands palm upwards in pacific gesture.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The muscles in Luca’s brown throat worked as he swallowed. The strong lines of his face were set in stone by the time he had regained his composure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Did I tell you what I heard her saying to Valentina?’ he asked in a soft voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, Luca.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Her "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("loving")])]), _vm._v(" grandmother was telling her what a shame it was she is not as beautiful and talented as her mother was. Telling her that if she had never been born her mother would not be dead.’ He drew a deep breath that expanded his powerful chest. ‘"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Dio")])]), _vm._v("…Tom, what was I to do?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tom, who was deeply shocked by these revelations, shrugged weakly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Who knows how long she has been dropping this poison in Valentina’s ears? I will not let it happen to my daughter. I will not permit history to repeat itself,’ he added half to himself. ‘The woman, she has no feelings for the child,’ he stated emphatically, adding the wry rider, ‘at least not as you or I understand it. For her Valentina is a weapon to punish me.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once more he rose to his feet, grim determination in every line of his tall and vital figure. ‘I have taken her contempt and vitriol over the years—it is of no matter to me.’ He shrugged. ‘But she has overstepped the mark this time. Valentina’s needs must be considered above all else.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘They’ll say it is in Valentina’s interests to be brought up ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("within a loving family,’ his friend pointed out gently. ‘They will try and paint you as a…’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘Work-obsessed womaniser, I know.’ His tight smile held self-mockery. ‘I suppose the Erica factor is going to come into it?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Tom nodded unhappily.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘And if I had sued the newspaper for libel as you, my friend, suggested at the time…?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘Considering you had Erica admitting on tape that the bruise was nothing but clever make-up I still think you should have exposed her publicly at the very least, but then I don’t have your gentlemanly code,’ he admitted drily. ‘Don’t beat yourself up over that, Luca, it’s easy to be wise in hindsight, but, yes, your refusal to defend yourself against those ludicrous accusations is going to look bad.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘Oh, but you forget there were no accusations—in fact the beautiful victim bravely denied I had laid a finger on her, if you recall—’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Tom looked uncomfortable. ‘Let’s concentrate on things we "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("can")])]), _vm._v(" do something about,’ he suggested. ‘It’s the male household factor that is a major stumbling block. The fact there is no female role model except for your…’ He paused, looking awkward.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘My "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("women")])]), _vm._v("?’ Luca bit back with a hard, satirical smile.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("The other man sighed. ‘You can forget about your personal life being sacrosanct if this thing comes to court, Luca. You’ll have to be prepared to have your love life dissected.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("‘I am not a monk,’ he admitted calmly. ‘However, my love life is not nearly as interesting as the press would have you believe.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("A laugh was wrenched from the lawyer. ‘If I don’t believe you, Luca, how do you expect to convince a court? And have you thought how Carlo is going to look to a judge? I mean, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I")])])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("know he’s a great chap but, let’s face it, he’s not most people’s idea of a nanny. And then there’s the matter of his record.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Carlo stays.’ There was no room for negotiation in Luca’s flat response and Tom, who knew personally of Luca’s un-swerving loyalty to his friends, did not argue the point. ‘But I can—’ The intercom on his desk buzzed and Luca’s dark brows drew together in a frown. When he spoke into the offending machine his tone was terse and impatient.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘I thought,’ he intoned coldly, ‘that I said I didn’t want—’ He stopped and listened to whatever was being said and sighed. ‘All right, tell him I’ll ring back in five minutes.’ He turned to the lawyer. ‘Sorry about this, Tom, but it’s Marco. He’s got a problem.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("And when Marco had a problem he always turned to his half-brother. Tom couldn’t prevent the look of disapproval that spread across his face. It was inexplicable to him that Luca, who did not tolerate fools gladly, should have such a fondness for his charming but feckless half-brother.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Luca saw the play of expression on his friend’s face. ‘You don’t like Marco do you?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Anyone "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("normal")])]), _vm._v(" would resent a half-brother who is favoured so unfairly, Luca.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Luca’s severe features relaxed slightly as a thoughtful expression slid into his silver-shot dark eyes. ‘Has it ever occurred to you that being considered incapable of doing anything wrong and supremely talented in all things by one’s parents is not an easy role to fill for anyone with the normal degree of human weaknesses?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("‘Well, Marco’s got his fair share of those,’ Tom conceded with a dry laugh. ‘But to be honest, Luca, I think it’s more of a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("burden")])]), _vm._v(" to have your achievements, not only go totally unrecognised by your family, but resented,’ he added, unable to repress his indignation on his friend’s behalf.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I do not seek anyone’s approval,’ Luca declared with chilling hauteur, which would have repressed nine men out of ten.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tom, the tenth, shook his head. ‘God, but you’re an arrogant beggar!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An unexpected grin of immense charm totally transformed the billionaire’s dark features. ‘That’s seemed to be the general consensus,’ Luca agreed drily. ‘I’ll ring you later,’ he added as the other man moved towards the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Are you going back to the house tonight? The renovations are completed?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘They are, but we’re staying in Marco’s apartment for a few nights. I didn’t say, Tom, but I am sorry to drag you away from Cape Cod.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I forgive you, but Alice might not.’ Tom smiled. ‘Luca, is there anything you want me to do in the meantime?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You could make up a list of possible brides.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This comment made the other man pause as he reached for the door handle. ‘I’ve known you ten years, Luca, and I still can’t tell when you’re joking.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’ve never been more serious in my life, Thomas.’")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("‘Mum, you’ve "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("got")])]), _vm._v(" to help me!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You expect me to drop everything, Jude?’ There was a note of laboured incredulity in Lyn Lucas’s husky voice that didn’t quite ring true. ‘Just like that!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Appealing to her mother’s maternal instincts always had been a long shot. ‘There’s a first time for everything,’ Jude muttered, rueful affection in her stressed voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What was that, Jude?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Nothing.’ She took a deep breath and swallowed her pride. If begging was what it took she was prepared to beg; things were really that desperate. ‘Listen, Mum, I wouldn’t ask unless this was an emergency.’")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘And if it were an emergency I would quite naturally be there for you,’ Lyn returned serenely. ‘But really, Jude, don’t you think you’re just a tad over the top with the drama, darling? They’re only three little children…just how much trouble can they be?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘How much? How "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("much")])]), _vm._v("?’ Jude standing in the middle of her open-plan living room, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("once")])]), _vm._v(" a tribute to tasteful minimalism, took a deep steadying breath. ‘Where,’ she asked as the weight of her failure oppressed her, ‘shall I start? Oh, God, Mum, it’s not "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("them")])]), _vm._v(", it’s "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("me")])]), _vm._v("!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The logical part of her knew she was wasting her breath. How could you explain to someone whose idea of hands-on parenting was giving her teenage daughter charge accounts and a car?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When they’d been younger a long series of nannies had made sure she and David had only ever been produced for parental inspection when they’d been freshly scrubbed and on their best behaviour. As soon as it had been possible they had been shipped off to boarding-school. That, she mused, was probably why they’d ended up being so close.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘The children need someone who knows what they’re doing,’ she began in a frustrated tone when from the corner of her eye she caught movement. ‘Hold on a minute, Mum,’ she grunted, diving to retrieve a bottle of hair conditioner before the five-year-old could apply it to the blond curls of her sleeping baby sister.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No, Sophia, that’s Aunty Jude’s.’ Jude was frustrated to see her firm but reasonable remonstration had no visible effect on the five-year-old. Maybe it’s not what I say but the way I say it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No!’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Don’t shout, Sophia, you’ll wake Amy,’ Jude pleaded, giving an anguished glance at the baby who stirred sleepily.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("The little girl finally relinquished the bottle upon being offered a chocolate biscuit in exchange. You didn’t have to be ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("a trained clinical psychologist like herself to know bribery wasn’t generally recommended as a method of child discipline, but Jude was frankly past caring about such niceties.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("David, a dentist, would have been horrified by her breaking his draconian ‘no sweeties or chocolate’ edict; a great tide of sadness that had physical heaviness washed over her as she thought of her brother. David wasn’t here to protect his children’s teeth and neither was his wife, Sam. They had been killed the previous month when their car had gone through the central reservation on the motorway and collided head-on with a lorry.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("When no other explanation for the accident had been forthcoming the inquest into the tragic deaths had concluded it was most likely the driver had fallen asleep at the wheel. The driver—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("David")])]), _vm._v(", her brother.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She knew all about the stages of the grieving process. Should that be helping? Jude didn’t know. She just knew that she didn’t have time to grieve, not yet. Right now her priority had to be three little children who needed a lot of love and understanding and the best way to do that seemed to be not trying to look more than a day ahead. If she did, the sense of her total inadequacy for the task that had been thrust upon her paralysed her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She had loved being "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Aunty")])]), _vm._v(" Jude, who could spoil and indulge them before handing them back at the end of the day. Having total responsibility was quite another matter, as she was learning!")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She wanted to make the children feel safe and secure after their little world had been blown apart, but it was hard when she was scared herself. Scared because for the first time in her life something wasn’t coming easy. She was failing at something, and this "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("something")])]), _vm._v(" wasn’t an exam or a job. You could resit an exam or change a job, but where children’s lives were concerned you didn’t get to go back and try again.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lately she’d begun to wonder if children, like animals, could smell fear. Well, whatever the reason, this brood had decided about ten seconds after they’d arrived that they didn’t have to do as she asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I have to face it my mothering instincts are dreadful, she decided dully. Somewhat ironic, not to mention embarrassing, for the author of the catchily entitled "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Parenting Skills for Beginners")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a token, ‘Don’t do that, sweetheart,’ to Sophia, who was smearing chocolatey fingerprints all over her new cream sofa, she wearily raised the receiver to her ear in time to hear her mother say—")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘What can they have done that is so bad? The twins are only three—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Five, Mum. The twins are five and Amy is eighteen months,’ Jude reminded her mother wearily. ‘And "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("they’ve")])]), _vm._v(" not done anything.’ How could she explain to her literally minded mother that it wasn’t the paintwork or the broken items she was worried about? That she hardly ever thought about the time when she had enjoyed coming back to her flat, kicking off her shoes and shutting the rest of the world out. ‘Amy cries for her mum, and Sophia has nightmares, and Joseph—he "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("doesn’t")])]), _vm._v(" cry.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, they’ve just lost their parents, Jude, what do you expect?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I know…I know, but it’s not just that. It’s this place, it’s really hard to contain and amuse three children under six in a one-bedroomed apartment, Mum. I need somewhere with a garden?’ she ended on a hopeful note.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her mother had stayed in the family home after the divorce, a rambling Edwardian house on the edge of a picture-postcard village set in two acres of child-friendly gardens.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Five is a delightful age, Jude,’ replied the children’s doting but absent grandmother with a catch in her voice. ‘And I’d "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("love")])]), _vm._v(" for you all to come and stay here—’")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You don’t know how glad I—’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘But unfortunately I have a meeting in New York this Friday and then guests next week. David,’ she recalled huskily, ‘was so sweet when he was five, so bright, so enquiring and so innocent…’ Her voice dissolved into tears. ‘I don’t know how you can ask me to help when I’m suffering so much,’ she reproached. ‘And work is my only solace, you know that, Jude.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘They were such a lovely couple,’ Lyn Lucas continued with a sigh. ‘With everything to look forward to. ‘Why them?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jude could only shake her head; her throat ached with unshed tears as she thought of her brother and his wife.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I can’t do this, Mum,’ she whispered miserably down the phone. ‘I’m messing up big time.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, David must have thought you could or he wouldn’t have named you as the children’s guardian,’ came the bracing response.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I doubt he expected I’d ever be put to the test,’ Jude retorted sadly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Well, you have, and you’ll just have to get on with it. It’ll be a lot easier when you’ve sold the flat and bought something more sensible,’ her mother continued. ‘A nice little place in the country somewhere,’ she mused as she conjured a picture of domestic bliss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I hate to ruin the roses-around-the-door scenario, but I have to live where the work is, Mum.’ Thankfully they were being really good about giving her time off at the university where she lectured, so that was one less thing for her to worry about right now.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("‘Is all this about your job, Jude? I must say I’m disappointed in you, but not surprised.’ Lyn sighed. ‘You always have had a selfish streak. I mean, there’s nothing "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("wrong")])]), _vm._v(" with a women having a career, but I would have thought under the ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("circumstances that you would have been prepared to make a little sacrifice.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("This breathtaking piece of hypocrisy coming from a mother who had never made a parents’ evening or sports day in her life left Jude momentarily speechless.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘This isn’t about my job, Mum,’ she managed finally. ‘Though financially I do have to work,’ she added drily. ‘I’m good at my job. I’m not good at—’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘There’s no such thing as the perfect parent, Jude,’ her mother interrupted. ‘Your problem is you’re a perfectionist; you always have been. You don’t like situations you can’t control, or people. Just look at your boyfriends.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Must we?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Not a single one of them had an opinion of his own.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘That’s a gross exaggeration, Mother,’ Jude retorted indignantly. ‘I’m just not attracted to men who order dinner for me.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("For a liberated woman her mother had some very old-fashioned views of men. After her father had gone to live abroad she and David had found a new ‘uncle’ in residence every holiday they’d come home. The only thing they’d had in common beside their short shelf-lives had been their overbearing personalities.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘I’ve lost track,’ she said, pressing her fingers to the pulse spots on her temple where the throbbing headache was building. ‘Why exactly is my taste in men relevant to you refusing to help me?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Children are not predictable, Jude.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘I’d noticed.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘You have to be flexible and compromise.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Jude was just too tired to fight. ‘I’ll try,’ she promised.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Good girl. It’s just a pity that you haven’t got a husband yet, because, let’s face it, no man’s going to look twice at a girl who comes with a ready-made family of three.’ And on ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("that cheery note, Jude thought, shaking her head slowly from side to side. My mum really is a one-off, which is probably just as well!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘Now, if there’s anything you need just ask.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("And you’ll be there for me so long as it doesn’t interfere with a bridge game. ‘Thanks, Mum.’")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f81e052","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/italiansruthlessmarriagebargainthe_ch01.vue
// module id = 72
// module chunks = 0